export const TOKEN_KEY = 'vinova-token'
export const INTERFACE_KEY = 'interfaceId'
export const ORG_KEY = 'orgId'
export const STATION_KEY = 'stationId'

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&._#-])[A-Za-z\d@$!%*?&#._-]{5,50}$/
export const METRIC_OPTIONS = [
  { value: 1, label: 'Metric' },
  { value: 2, label: 'Imperial' },
]

export const GMT_OPTIONS = [
  { value: -12, label: 'GMT-12' },
  { value: -11, label: 'GMT-11' },
  { value: -10, label: 'GMT-10' },
  { value: -9, label: 'GMT-9' },
  { value: -8, label: 'GMT-8' },
  { value: -7, label: 'GMT-7' },
  { value: -6, label: 'GMT-6' },
  { value: -5, label: 'GMT-5' },
  { value: -4, label: 'GMT-4' },
  { value: -3, label: 'GMT-3' },
  { value: -2, label: 'GMT-2' },
  { value: -1, label: 'GMT-1' },
  { value: +0, label: 'GMT+0' },
  { value: +1, label: 'GMT+1' },
  { value: +2, label: 'GMT+2' },
  { value: +3, label: 'GMT+3' },
  { value: +4, label: 'GMT+4' },
  { value: +5, label: 'GMT+5' },
  { value: +6, label: 'GMT+6' },
  { value: +7, label: 'GMT+7' },
  { value: +8, label: 'GMT+8' },
  { value: +9, label: 'GMT+9' },
  { value: +10, label: 'GMT+10' },
  { value: +11, label: 'GMT+11' },
  { value: +12, label: 'GMT+12' },
  { value: +13, label: 'GMT+13' },
  { value: +14, label: 'GMT+14' },
]
export const SETUP_GMT_OPTIONS = [
  // { value: -12, label: 'GMT-12' },
  { value: -11, label: 'GMT-11 (Pacific/Pago_Pago)' },
  { value: -10, label: 'GMT-10 (Pacific/Honolulu)' },
  { value: -9, label: 'GMT-9 (America/Anchorage)' },
  { value: -8, label: 'GMT-8 (America/Los_Angeles)' },
  { value: -7, label: 'GMT-7 (America/Denver)' },
  { value: -6, label: 'GMT-6 (America/Chicago)' },
  { value: -5, label: 'GMT-5 (America/Toronto)' },
  { value: -4, label: 'GMT-4 (America/Boa_Vista)' },
  { value: -3, label: 'GMT-3 (America/Santiago)' },
  { value: -2, label: 'GMT-2 (America/Sao_Paulo)' },
  { value: -1, label: 'GMT-1 (Atlantic/Azores)' },
  { value: +0, label: 'GMT+0 (Europe/London)' },
  { value: +1, label: 'GMT+1 (Europe/Paris)' },
  { value: +2, label: 'GMT+2 (Asia/Amman)' },
  { value: +3, label: 'GMT+3 (Asia/Qatar)' },
  { value: +4, label: 'GMT+4 (Asia/Dubai)' },
  { value: +5, label: 'GMT+5 (Indian/Maldives)' },
  { value: +6, label: 'GMT+6 (Asia/Almaty)' },
  { value: +7, label: 'GMT+7 (Asia/Saigon)' },
  { value: +8, label: 'GMT+8 (Asia/Singapore)' },
  { value: +9, label: 'GMT+9 (Asia/Seoul)' },
  { value: +10, label: 'GMT+10 (Australia/Brisbane)' },
  { value: +11, label: 'GMT+11 (Antarctica/Casey)' },
  { value: +12, label: 'GMT+12 (Pacific/Funafuti)' },
  { value: +13, label: 'GMT+13 (Pacific/Auckland)' },
  { value: +14, label: 'GMT+14 (Pacific/Kiritimati)' },
]

export const minuteMapping: { [key: number]: number } = {
  '-20': 40,
  '-19': 41,
  '-18': 42,
  '-17': 43,
  '-16': 44,
  '-15': 45,
  '-14': 46,
  '-13': 47,
  '-12': 48,
  '-11': 49,
  '-10': 50,
  '-9': 51,
  '-8': 52,
  '-7': 53,
  '-6': 54,
  '-5': 55,
  '-4': 56,
  '-3': 57,
  '-2': 58,
  '-1': 59,
  '-40': 20,
  '-41': 19,
  '-42': 18,
  '-43': 17,
  '-44': 16,
  '-45': 15,
  '-46': 14,
  '-47': 13,
  '-48': 12,
  '-49': 11,
  '-30': 30,
  '-31': 29,
  '-32': 28,
  '-33': 27,
  '-34': 26,
  '-35': 25,
  '-36': 24,
  '-37': 23,
  '-38': 22,
  '-39': 21,
  '-50': 10,
  '-51': 9,
  '-52': 8,
  '-53': 7,
  '-54': 6,
  '-55': 5,
  '-56': 4,
  '-57': 3,
  '-58': 2,
  '-59': 1,
}

export const MENU = [
  {
    title: 'Interface',
    titleKey: 'navigationAdminInterface',
    href: '/admin/interface',
  },
  {
    title: 'Organizations',
    titleKey: 'navigationAdminOrganizations',
    href: '/admin/organizations',
  },
  {
    title: 'Administrators',
    titleKey: 'navigationAdminAdministrators',
    href: '/admin/administrators',
  },
  {
    title: 'Manage Users',
    titleKey: 'navigationAdminManageUsers',
    href: '/admin/manage-users',
  },
  {
    title: 'Third Party Sensors',
    titleKey: 'navigationAdminThirdPartySensors',
    href: '/admin/third-party-sensors',
  },
]

export const MENU_RADIO_OPERATIONS = [
  {
    label: 'By Stations',
    href: '/operations/dashboard/manual-station',
    value: 'manual-station',
  },
  {
    label: 'By Programs',
    href: '/operations/dashboard/manual-programs',
    value: 'manual-programs',
  },
]

export const DATA_TABLE_INTERFACE = [
  {
    id: '1',
    interface_name: 'Gardens By The Bay',
    organization: 'CIS',
    site: 'Setup Sites & Maps',
    dashboard: 'Launch',
    status: 'Active',
    updated_at: '24/02/2022',
    time_updated_at: '11:32',
    created_at: '11/02/2022',
    time_created_at: '11:32',
  },
  {
    id: '2',
    interface_name: 'Interface2',
    organization: 'Org Name',
    site: 'Manage',
    dashboard: 'Launch',
    status: 'Inactive',
    updated_at: '24/02/2022',
    time_updated_at: '11:32',
    created_at: '11/02/2022',
    time_created_at: '11:32',
  },
  {
    id: '3',
    interface_name: 'Interface3',
    organization: 'CIS',
    site: 'Setup Sites & Maps',
    dashboard: 'Launch',
    status: 'Active',
    updated_at: '24/02/2022',
    time_updated_at: '11:32',
    created_at: '11/02/2022',
    time_created_at: '11:32',
  },
]

export const DATA_TABLE_WEATHER_LINK = [
  {
    id: '1',
    name: 'Station Name 1',
    location: 'Singapore, Singapore',
    numberOfSensors: 12,
    subscriptionEndDate: '2023-04-11T07:15:00',
  },
  {
    id: '1',
    name: 'Station Name 2',
    location: 'Singapore, Singapore',
    numberOfSensors: 5,
    subscriptionEndDate: '2023-04-11T07:15:00',
  },
]

export const DATA_TABLE_INTERFACE_DETAIL = [
  {
    id: 1,
    site_name: 'Gardens By The Bay',
    floor: '1',
  },
  {
    id: 2,
    site_name: 'Bay East',
    floor: '1',
  },
]

export const DATA_TABLE_ADMINISTRATORS = [
  {
    id: '1',
    admin_name: 'Sam Raberra',
    admin_email: 'sam@cisgenic.com',
    role: 'Admin',
    status: 'Active',
  },
  {
    id: '2',
    admin_name: 'John Smith',
    admin_email: 'user@email.com',
    role: 'Admin',
    status: 'Inactive',
  },
]

export const DATA_TABLE_ORGANIZATIONS = [
  {
    id: '1',
    organization_name: 'CIS',
    isParent: 'Yes',
    organization_id: '-',
    parent_organization: '-',
    users_staff: 'MANAGE',
  },
  {
    id: '2',
    organization_name: 'Org Name 1',
    isParent: 'Yes',
    organization_id: '-',
    parent_organization: '-',
    users_staff: 'MANAGE',
  },
  {
    id: '3',
    organization_name: 'Org Name 2',
    isParent: 'No',
    organization_id: '0',
    parent_organization: 'Org Name 1',
    users_staff: 'MANAGE',
  },
]

export const DATA_TABLE_ORGANIZATIONS_DETAIL = [
  {
    id: '1',
    staff_name: 'Sam Raberra',
    email: 'sam@cisgenic.com',
    role: 'Admin',
    status: 'Active',
  },
  {
    id: '2',
    staff_name: 'John Smith',
    email: 'user@email.com',
    role: 'Admin',
    status: 'Inactive',
  },
]

export const DATA_TABLE_STATIONS = [
  {
    id: '1',
    controller: 'S1C1',
    decoder: 'Irrigation',
    state: 'On',
    plant: 'Shrubs',
    emitter: 'Emitter',
    et: '5m00s',
  },
  {
    id: '2',
    controller: 'S1C1',
    decoder: 'Irrigation',
    state: 'On',
    plant: 'Shrubs',
    emitter: 'Emitter',
    et: '5m00s',
  },
  {
    id: '3',
    controller: 'S1C1',
    decoder: 'Irrigation',
    state: 'On',
    plant: 'Shrubs',
    emitter: 'Emitter',
    et: '5m00s',
  },
  {
    id: '4',
    controller: 'S1C1',
    decoder: 'Irrigation',
    state: 'Off',
    plant: 'Shrubs',
    emitter: 'Emitter',
    et: '5m00s',
  },
  {
    id: '5',
    controller: 'S1C1',
    decoder: 'Irrigation',
    state: 'Error',
    plant: 'Shrubs',
    emitter: 'Emitter',
    et: '5m00s',
  },
]

export const DATA_TABLE_ETZ = [
  {
    ETzone: 'ETZ1',
    soil: '15',
    vapour: '15',
    atomspheric: '15',
    speed: '15',
    number: '15',
    relative: '15',
    temperature: '15',
    flux: '15',
    shortwaver: '15',
    duration: '15',
    quantity: '3',
    irrigation_type: 'Text',
    vegetation: 'Text',
    type: 'Text',
    irrigation_time: '15',
  },
  {
    ETzone: 'ETZ2',
    soil: '15',
    vapour: '15',
    atomspheric: '15',
    speed: '15',
    number: '15',
    relative: '15',
    temperature: '15',
    flux: '15',
    shortwaver: '15',
    duration: '15',
    quantity: '3',
    irrigation_type: 'Text',
    vegetation: 'Text',
    type: 'Text',
    irrigation_time: '15',
  },
  {
    ETzone: 'ETZ3',
    soil: '15',
    vapour: '15',
    atomspheric: '15',
    speed: '15',
    number: '15',
    relative: '15',
    temperature: '15',
    flux: '15',
    shortwaver: '15',
    duration: '15',
    quantity: '3',
    irrigation_type: 'Text',
    vegetation: 'Text',
    type: 'Text',
    irrigation_time: '15',
  },
  {
    ETzone: 'ETZ4',
    soil: '15',
    vapour: '15',
    atomspheric: '15',
    speed: '15',
    number: '15',
    relative: '15',
    temperature: '',
    flux: '15',
    shortwaver: '15',
    duration: '15',
    quantity: '3',
    irrigation_type: 'Text',
    vegetation: 'Text',
    type: 'Text',
    irrigation_time: '15',
  },
  {
    ETzone: 'ETZ5',
    soil: '15',
    vapour: '15',
    atomspheric: '15',
    speed: '15',
    number: '15',
    relative: '15',
    temperature: '15',
    flux: '15',
    shortwaver: '15',
    duration: '15',
    quantity: '3',
    irrigation_type: 'Text',
    vegetation: 'Text',
    type: 'Text',
    irrigation_time: '15',
  },
]

export const DATA_TABLE_SENSORS = [
  {
    id: '1',
    name: 'S1C1',
    type: 'Soil Moisture',
    source: 'Cisgenics',
  },
  {
    id: '2',
    name: 'S1C2',
    type: 'Leaf Wetness',
    source: 'WeatherLink',
  },
  {
    id: '3',
    name: 'S1C3',
    type: 'Flow Sensor',
    source: 'Cisgenics',
  },
  {
    id: '4',
    name: 'S1C4',
    type: 'Pressure Sensor',
    source: 'WeatherLink',
  },
]

export const DATA_TABLE_EMITTER = [
  {
    id: '1',
    emitter: 'Emitter',
    efficiency: '55',
  },
  {
    id: '2',
    emitter: 'Emitter',
    efficiency: '50',
  },
]

export const DATA_TABLE_HISTORICAL = [
  {
    id: '1',
    description: 'Write something',
    jan: '56',
    feb: '52',
    mar: '57',
    apr: '79',
    may: '46',
    jun: '23',
    jul: '15',
    aug: '60',
    sep: '33',
    oct: '70',
    nov: '51',
    dec: '39',
  },
  {
    id: '2',
    description: 'Write something',
    jan: '62',
    feb: '29',
    mar: '80',
    apr: '22',
    may: '32',
    jun: '17',
    jul: '13',
    aug: '65',
    sep: '55',
    oct: '43',
    nov: '42',
    dec: '53',
  },
]

export const DATA_TABLE_SOIL = [
  {
    id: '1',
    soil_description: 'Description',
    holding_capacity: '3',
    wilting_point: '1',
    intake_rate: '25.56',
    surface: '14.40',
  },
  {
    id: '2',
    soil_description: 'Description',
    holding_capacity: '2',
    wilting_point: '5',
    intake_rate: '30.00',
    surface: '15.50',
  },
]

export const LIST_CONTROLLER = [
  { id: 1, itemName: 'Select one' },
  { id: 2, itemName: 'Controller' },
]

export const LIST_TYPE = [
  { id: 1, itemName: 'Select one' },
  { id: 3, itemName: 'Type' },
]

export const LIST_CONFIGURE = [
  { id: 1, itemName: 'Default with verify' },
  { id: 2, itemName: 'Configure' },
]

export const LIST_PIPE = [
  { id: 1, itemName: 'Select one' },
  { id: 2, itemName: 'Pipe' },
]

export const LIST_SOIL = [
  { id: 1, itemName: 'Select one' },
  { id: 2, itemName: 'Soil' },
]

export const LIST_STATION = [
  { id: 1, itemName: 'Select one' },
  { id: 2, itemName: 'Station Group' },
]

export const LIST_WATER = [
  { id: 1, itemName: 'Select one' },
  { id: 2, itemName: 'Water Required' },
]

export const LIST_SURFACE = [
  { id: 1, itemName: 'Select one' },
  { id: 2, itemName: 'Surface Accumulation' },
]

export const LIST_GATEWAY = [
  { id: 1, itemName: 'Input' },
  { id: 2, itemName: 'Gateway' },
]

export const LIST_CONFIGURATION = [
  { id: 1, itemName: 'Select configuration' },
  { id: 2, itemName: 'Configuration' },
  { id: 3, itemName: 'Text' },
]

export const LIST_TYPE_SENSOR = [
  { id: 1, itemName: 'Select type' },
  { id: 2, itemName: 'Type' },
]

export const LIST_SITE = [
  { id: 1, itemName: 'Select site' },
  { id: 2, itemName: 'Site' },
]

export const LIST_AREA = [
  { id: 1, itemName: 'Select area' },
  { id: 2, itemName: 'Area' },
]

export const LIST_CONTROLLER_SENSOR = [
  { id: 1, itemName: 'Select Controller' },
  { id: 2, itemName: 'Controller' },
]

export const LIST_VENDOR = [
  { id: 1, itemName: 'Select Vendor' },
  { id: 2, itemName: 'Vendor' },
]

export const LIST_MODEL = [
  { id: 1, itemName: 'Select Model' },
  { id: 2, itemName: 'Model' },
]

export const LIST_CONTROLLER_STATIONS1 = [
  {
    id: 1,
    name: 'S1C1',
  },
  {
    id: 2,
    name: 'S1C2',
  },
  {
    id: 3,
    name: 'S1C3',
  },
  {
    id: 4,
    name: 'S1C4',
  },
  {
    id: 5,
    name: 'S1C5',
  },
  {
    id: 6,
    name: 'S1C6',
  },
]

export const LIST_CONTROLLER_STATIONS2 = [
  {
    id: 1,
    name: 'S2C1',
  },
  {
    id: 2,
    name: 'S2C2',
  },
  {
    id: 3,
    name: 'S2C3',
  },
]

export const LIST_CONTROLLER_NAME_STATIONS = [
  {
    id: '1',
    action: 'Playground',
  },
  {
    id: '2',
    action: 'Playground',
  },
  {
    id: '3',
    action: 'Playground',
  },
  {
    id: '4',
    action: 'Playground',
  },
  {
    id: '5',
    action: 'Playground',
  },
  {
    id: '6',
    action: 'Playground',
  },
  {
    id: '7',
    action: 'Playground',
  },
]
export const LIST_CONTROLLER_STATIONS = [
  {
    id: 1,
    name: 'Location 1',
    LIST_CONTROLLER_NAME_STATIONS,
  },
  {
    id: 2,
    name: 'Location 2',
    LIST_CONTROLLER_NAME_STATIONS,
  },
  {
    id: 3,
    name: 'Location 3',
    LIST_CONTROLLER_NAME_STATIONS,
  },
  {
    id: 4,
    name: 'Location 4',
    LIST_CONTROLLER_NAME_STATIONS,
  },
  {
    id: 5,
    name: 'Location 5',
    LIST_CONTROLLER_NAME_STATIONS,
  },
  {
    id: 6,
    name: 'Location 6',
    LIST_CONTROLLER_NAME_STATIONS,
  },
  {
    id: 7,
    name: 'Location 7',
    LIST_CONTROLLER_NAME_STATIONS,
  },
  {
    id: 8,
    name: 'Location 8',
    LIST_CONTROLLER_NAME_STATIONS,
  },
  {
    id: 9,
    name: 'Location 9',
    LIST_CONTROLLER_NAME_STATIONS,
  },
]

export const DATA_TABLE_PROGRAMS = [
  {
    id: '1',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '2',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Odd',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '3',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '4',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '5',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '6',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '7',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '8',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '9',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '10',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '11',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
  {
    id: '12',
    name: 'Programs',
    from: '1 Jan 22',
    to: '31 Dec 22',
    days: 'M T W T F S S',
    odd_event: 'Custom',
    time: '6:00AM - 8:00AM',
    pm: 'MAD',
    rt: '00:00:00',
    etv: '0',
  },
]

export const DATA_TABLE_SITES = [
  {
    id: '1',
    location: 'Location 1',
  },
  {
    id: '2',
    location: 'Location 2',
  },
  {
    id: '3',
    location: 'Location 3',
  },
  {
    id: '4',
    location: 'Location 4',
  },
]

export const DATA_TABLE_CONTROLLERS = [
  {
    id: '1',
    controller: 'S1C1',
    controller_description: 'Controller description',
  },
  {
    id: '2',
    controller: 'S1C2',
    controller_description: 'Controller description',
  },
  {
    id: '3',
    controller: 'S2C1',
    controller_description: 'Controller description',
  },
  {
    id: '4',
    controller: 'S2C2',
    controller_description: 'Controller description',
  },
]

export const DATA_TABLE_PLANT = [
  {
    id: '1',
    plant_description: 'Description',
    water_reference: 'Water Reference',
    allowable_depletion: 'Allowable Depletion',
    refill_to: 'Refill to (%)',
    root_zone: 'Root Zone',
    plant_factor: 'Plant Factor',
  },
  {
    id: '2',
    plant_description: 'Description',
    water_reference: 'Water Reference',
    allowable_depletion: 'Allowable Depletion',
    refill_to: 'Refill to (%)',
    root_zone: 'Root Zone',
    plant_factor: 'Plant Factor',
  },
]

export const DATA_TABLE_PUMPS = [
  {
    id: '1',
    site: 'Select',
    description: 'Write Something',
    controller: 'Programs',
    active: 'Programs',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: 'Start Delay',
    stop_delay: 'Stop Delay',
    capacity: 'Capacity',
  },
]

export const LIST_ACTIVE = [
  { id: 1, itemName: 'Select One' },
  { id: 2, itemName: 'Yes' },
]

export const DATA_TABLE_PIPE = [
  {
    id: '1',
    subpipe: 'Sub Main 1',
    pipe: '1',
    controller: 'Text',
    pipeCapacity: '65',
  },
  {
    id: '2',
    subpipe: 'Sub Main 2',
    pipe: '2',
    controller: 'Text',
    pipeCapacity: '65',
  },
  {
    id: '3',
    subpipe: 'Sub Main 3',
    pipe: '3',
    controller: 'Text',
    pipeCapacity: '65',
  },
]

export const DATA_SOIL_MOISTURE = {
  moistures: [
    {
      time: '2023-06-29T17:00:00.000Z',
      value: 98,
    },
    {
      time: '2023-06-30T19:00:00.000Z',
      value: 100,
    },
    {
      time: '2023-06-31T20:00:00.000Z',
      value: 100,
    },
  ],
  eCs: [
    {
      time: '2023-06-29T17:00:00.000Z',
      value: 120,
    },
    {
      time: '2023-06-30T17:00:00.000Z',
      value: 102,
    },
    {
      time: '2023-06-31T17:00:00.000Z',
      value: 104,
    },
  ],
  temps: [
    {
      time: '2023-06-29T17:00:00.000Z',
      value: 180,
    },
    {
      time: '2023-06-30T17:00:00.000Z',
      value: 190,
    },
    {
      time: '2023-06-31T17:00:00.000Z',
      value: 150,
    },
  ],
}

export const DATA_HISTORY_SENSOR = {
  wetness: [
    {
      time: '2023-06-29T17:00:00.000Z',
      value: 98,
    },
    {
      time: '2023-06-30T19:00:00.000Z',
      value: 100,
    },
    {
      time: '2023-06-31T20:00:00.000Z',
      value: 100,
    },
  ],
}

export const DATA_TABLE_STATIONS_OPERATIONS = [
  {
    id: '1',
    station: 'Area A - Center (R) Turf',
    state: 'Idling',
    et: '5m20s',
    mad: '5m00s',
    wp: '10m00s',
  },
  {
    id: '2',
    station: 'Area A - Center (R) Turf',
    state: 'Idling',
    et: '5m20s',
    mad: '5m00s',
    wp: '10m00s',
  },
  {
    id: '3',
    station: 'Area A - Center (R) Turf',
    state: 'Idling',
    et: '5m20s',
    mad: '5m00s',
    wp: '10m00s',
  },
  {
    id: '4',
    station: 'Area A - Center (R) Turf',
    state: 'Idling',
    et: '5m20s',
    mad: '5m00s',
    wp: '10m00s',
  },
  {
    id: '5',
    station: 'Area A - Center (R) Turf',
    state: 'Idling',
    et: '5m20s',
    mad: '5m00s',
    wp: '10m00s',
  },
]

export const DATA_TABLE_SOIL_SETUP = [
  {
    id: '1',
    soil_description: 'Soil A',
    water_reference: 'Text',
    holding_capacity: '100',
    wilting_point: '85.00',
    intake_rate: '85',
    surface: '55.00',
  },
  {
    id: '2',
    soil_description: 'Soil B',
    water_reference: 'Text',
    holding_capacity: '100',
    wilting_point: '85.00',
    intake_rate: '85',
    surface: '55.00',
  },
]

export const DATA_TABLE_PUMPS_SETUP = [
  {
    id: '1',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
  {
    id: '2',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
  {
    id: '3',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
  {
    id: '4',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
  {
    id: '5',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
  {
    id: '6',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
  {
    id: '7',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
  {
    id: '8',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
  {
    id: '9',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
  {
    id: '10',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
  {
    id: '11',
    site: 'Select',
    description: 'Write something',
    controller: 'Programs',
    active: 'Yes',
    pipe: 'Programs',
    priority: 'Priority',
    io: 'IO',
    start_delay: '15',
    stop_delay: '15',
    capacity: '250',
  },
]

export const DATA_TABLE_SITES_SETUP = [
  {
    id: '1',
    location: 'Flower Dome',
  },
  {
    id: '2',
    location: 'Cool Moist',
  },
  {
    id: '3',
    location: 'Active Garden',
  },
  {
    id: '4',
    location: 'Outdoor 1',
  },
  {
    id: '5',
    location: 'Outdoor 1',
  },
  {
    id: '6',
    location: 'Outdoor 1',
  },
  {
    id: '7',
    location: 'Outdoor 1',
  },
  {
    id: '8',
    location: 'Outdoor 1',
  },
  {
    id: '9',
    location: 'Outdoor 1',
  },
  {
    id: '10',
    location: 'Outdoor 1',
  },
  {
    id: '11',
    location: 'Outdoor 1',
  },
  {
    id: '12',
    location: 'Outdoor 1',
  },
]

export const DATA_TABLE_STATION_SETUP = [
  {
    id: '1',
    description: 'Kid Playground 1',
    controller: 'S1C1',
    decoder: 'Standard',
    address: '678088724',
    index: '1',
    type: '0',
    configure: 'Default with verify',
    priority: '1',
    gps_coordinates: '1.232654, 0.298298',
    station_group: 'Kids Playground 1 ',
    pipe: 'Text',
    soil: 'Text',
    water_required: 'Text',
    surface_accumulation: 'Text',
    plant: 'Text',
    precipitation_rate: 'Text',
    expected_flow: 'Text',
    landscape_factor: '90',
    program: 'Text',
    plant_group: 'Text',
    precip: '90',
    efficiency: '100',
    manual: '5',
    et_node: 'B',
  },
  {
    id: '2',
    description: 'Kid Playground 1',
    controller: 'S1C1',
    decoder: 'Standard',
    address: '678088724',
    index: '1',
    type: '0',
    configure: 'Default with verify',
    priority: '1',
    gps_coordinates: '1.232654, 0.298298',
    station_group: 'Kids Playground 1 ',
    pipe: 'Text',
    soil: 'Text',
    water_required: 'Text',
    surface_accumulation: 'Text',
    plant: 'Text',
    precipitation_rate: 'Text',
    expected_flow: 'Text',
    landscape_factor: '90',
    program: 'Text',
    plant_group: 'Text',
    precip: '90',
    efficiency: '100',
    manual: '5',
    et_node: 'B',
  },
  {
    id: '3',
    description: 'Kid Playground 1',
    controller: 'S1C1',
    decoder: 'Standard',
    address: '678088724',
    index: '1',
    type: '0',
    configure: 'Default with verify',
    priority: '1',
    gps_coordinates: '1.232654, 0.298298',
    station_group: 'Kids Playground 1 ',
    pipe: 'Text',
    soil: 'Text',
    water_required: 'Text',
    surface_accumulation: 'Text',
    plant: 'Text',
    precipitation_rate: 'Text',
    expected_flow: 'Text',
    landscape_factor: '90',
    program: 'Text',
    plant_group: 'Text',
    precip: '90',
    efficiency: '100',
    manual: '5',
    et_node: 'B',
  },
  {
    id: '4',
    description: 'Kid Playground 1',
    controller: 'S1C1',
    decoder: 'Standard',
    address: '678088724',
    index: '1',
    type: '0',
    configure: 'Default with verify',
    priority: '1',
    gps_coordinates: '1.232654, 0.298298',
    station_group: 'Kids Playground 1 ',
    pipe: 'Text',
    soil: 'Text',
    water_required: 'Text',
    surface_accumulation: 'Text',
    plant: 'Text',
    precipitation_rate: 'Text',
    expected_flow: 'Text',
    landscape_factor: '90',
    program: 'Text',
    plant_group: 'Text',
    precip: '90',
    efficiency: '100',
    manual: '5',
    et_node: 'B',
  },
  {
    id: '5',
    description: 'Kid Playground 1',
    controller: 'S1C1',
    decoder: 'Standard',
    address: '678088724',
    index: '1',
    type: '0',
    configure: 'Default with verify',
    priority: '1',
    gps_coordinates: '1.232654, 0.298298',
    station_group: 'Kids Playground 1 ',
    pipe: 'Text',
    soil: 'Text',
    water_required: 'Text',
    surface_accumulation: 'Text',
    plant: 'Text',
    precipitation_rate: 'Text',
    expected_flow: 'Text',
    landscape_factor: '90',
    program: 'Text',
    plant_group: 'Text',
    precip: '90',
    efficiency: '100',
    manual: '5',
    et_node: 'B',
  },
  {
    id: '6',
    description: 'Kid Playground 1',
    controller: 'S1C1',
    decoder: 'Standard',
    address: '678088724',
    index: '1',
    type: '0',
    configure: 'Default with verify',
    priority: '1',
    gps_coordinates: '1.232654, 0.298298',
    station_group: 'Kids Playground 1 ',
    pipe: 'Text',
    soil: 'Text',
    water_required: 'Text',
    surface_accumulation: 'Text',
    plant: 'Text',
    precipitation_rate: 'Text',
    expected_flow: 'Text',
    landscape_factor: '90',
    program: 'Text',
    plant_group: 'Text',
    precip: '90',
    efficiency: '100',
    manual: '5',
    et_node: 'B',
  },
  {
    id: '7',
    description: 'Kid Playground 1',
    controller: 'S1C1',
    decoder: 'Standard',
    address: '678088724',
    index: '1',
    type: '0',
    configure: 'Default with verify',
    priority: '1',
    gps_coordinates: '1.232654, 0.298298',
    station_group: 'Kids Playground 1 ',
    pipe: 'Text',
    soil: 'Text',
    water_required: 'Text',
    surface_accumulation: 'Text',
    plant: 'Text',
    precipitation_rate: 'Text',
    expected_flow: 'Text',
    landscape_factor: '90',
    program: 'Text',
    plant_group: 'Text',
    precip: '90',
    efficiency: '100',
    manual: '5',
    et_node: 'B',
  },
  {
    id: '8',
    description: 'Kid Playground 1',
    controller: 'S1C1',
    decoder: 'Standard',
    address: '678088724',
    index: '1',
    type: '0',
    configure: 'Default with verify',
    priority: '1',
    gps_coordinates: '1.232654, 0.298298',
    station_group: 'Kids Playground 1 ',
    pipe: 'Text',
    soil: 'Text',
    water_required: 'Text',
    surface_accumulation: 'Text',
    plant: 'Text',
    precipitation_rate: 'Text',
    expected_flow: 'Text',
    landscape_factor: '90',
    program: 'Text',
    plant_group: 'Text',
    precip: '90',
    efficiency: '100',
    manual: '5',
    et_node: 'B',
  },
  {
    id: '9',
    description: 'Kid Playground 1',
    controller: 'S1C1',
    decoder: 'Standard',
    address: '678088724',
    index: '1',
    type: '0',
    configure: 'Default with verify',
    priority: '1',
    gps_coordinates: '1.232654, 0.298298',
    station_group: 'Kids Playground 1 ',
    pipe: 'Text',
    soil: 'Text',
    water_required: 'Text',
    surface_accumulation: 'Text',
    plant: 'Text',
    precipitation_rate: 'Text',
    expected_flow: 'Text',
    landscape_factor: '90',
    program: 'Text',
    plant_group: 'Text',
    precip: '90',
    efficiency: '100',
    manual: '5',
    et_node: 'B',
  },
  {
    id: '10',
    description: 'Kid Playground 1',
    controller: 'S1C1',
    decoder: 'Standard',
    address: '678088724',
    index: '1',
    type: '0',
    configure: 'Default with verify',
    priority: '1',
    gps_coordinates: '1.232654, 0.298298',
    station_group: 'Kids Playground 1 ',
    pipe: 'Text',
    soil: 'Text',
    water_required: 'Text',
    surface_accumulation: 'Text',
    plant: 'Text',
    precipitation_rate: 'Text',
    expected_flow: 'Text',
    landscape_factor: '90',
    program: 'Text',
    plant_group: 'Text',
    precip: '90',
    efficiency: '100',
    manual: '5',
    et_node: 'B',
  },
]
export const DATA_TABLE_STATIONS_ASSIGNMENT_SETUP = [
  {
    id: '1',
    description: 'Kids Playground 1',
    pipe: 'S1C1',
    soil: '678088724',
    water_required: '1',
    surface_accumulation: '1',
    plant_water: '1',
    precipitation_rate: '1',
    expected_flow: '1',
    landscape: '1',
    program: '1',
    plant_group: '0',
    precip: 'Default with verify',
    emitter: '100',
    efficiency: '100',
    manual_ops: '100',
    et_node: '100',
  },
  {
    id: '2',
    description: 'Text',
    pipe: 'Text',
    soil: 'Text',
    water_required: '2',
    surface_accumulation: '2',
    plant_water: '2',
    precipitation_rate: '2',
    expected_flow: '2',
    landscape: '2',
    program: '2',
    plant_group: '0',
    precip: 'Default with verify',
    emitter: 'Text',
    efficiency: 'Text',
    manual_ops: 'Text',
    et_node: 'Text',
  },
]

export const DATA_TABLE_MANAGE = [
  { id: '1', locationName: 'Location1', floors: '12' },
  { id: '2', locationName: 'Location2', floors: '24' },
  { id: '3', locationName: 'Location3', floors: '10' },
]

export const queryKeys = {
  organization: 'useOrgs',
  organizationV2: 'useOrgsV2',
  organizationByUserV2: 'useOrgsByUserV2',
  userOrganizationV2: 'useUserOrganizationV2',
  interfaceOrg: 'useInterfaceOrg',
  interfacePermissionsOrg: 'useInterfacePermissionsOrg',
  myInterfaceOrg: 'useMyInterfaceOrg',
  monthlyET: 'monthlyET',
  admin: 'useAdmin',
  alerts: 'useAlerts',
  notifications: 'useNotifications',
  controller: 'useController',
  historical: 'useHistorical',
  interface: 'useInterface',
  interfaceV2: 'useInterfaceV2',
  userByInterface: 'useUserByInterface',
  location: 'useLocation',
  weatherLink: 'weatherLink',
  site: 'useSite',
  userOrg: 'useUserOrgs',
  userOrgV2: 'useUserOrgsV2',
  user: 'useUser',
  floor: 'useFloor',
  interfaceByRole: 'useInterfaceByRole',
  plant: 'usePlant',
  soil: 'useSoil',
  sensor: 'useSensor',
  emitter: 'useEmitter',
  twowire: 'useTwowire',
  siteLocation: 'sitesAndLocation',
  stations: 'useStation',
  digitalTwinLive: 'useDigitalTwinLive',
  siteOverlay: 'useSiteOverlay',
  weather: 'useWeather',
  weatherHumidity: 'useHumidityWeather',
  weatherET: 'useETWeather',
  weatherRain: 'useRainWeather',
  weatherTotalRain: 'useTotalRainWeather',
  weatherBaro: 'useBaroWeather',
  weatherWindSpeed: 'useWindSpeedWeather',
  weatherWaterUsage: 'weatherWaterUsage',
  weatherSolar: 'useSolarWeather',
  weatherTHSWIndex: 'useTHSWWeather',
  weatherTemperature: 'useTemperatureWeather',
  weatherWindRose: 'useWindRoseWeather',
  weatherWindDirection: 'weatherWindDirection',
  weatherReport: 'useWeatherReport',
  program: 'program',
  commonData: 'commonData',
  station: 'station',
  manualOperation: 'useManualOperation',
  setupCommonData: 'useSetupCommonData',
  setupOrverAllStatus: 'setupOrverAllStatus',
  timezone: 'useTimezone',
  timezoneOptions: 'useTimezoneOptions',
  measureOptions: 'useMeasureOptions',
  etReference: 'useEtReference',
  etZone: 'useEtZone',
  testMode: 'useTestMode',
  simulation: 'useSimulation',
  fertigation: 'useFertigation',
  cisFertigation: 'useCisFertigation',
  widgetDashboard: 'useWidgetDashboard',
  widgetDetailDashboard: 'widgetDetailDashboard',
  cisFertigationByPipes: 'useCisFertigationByPipes',
  fertigationId: 'useFertigationId',
  cisFertigationId: 'useCisFertigationId',
  cisFertigationMode: 'cisFertigationMode',
  flowSimulation: 'useFlowSimulation',
  historyFlow: 'useHistoryFlow',
  historyNextMonthTotalWaterUsage: 'historyNextMonthTotalWaterUsage',
  programSimulation: 'useProgramSimulation',
  programHistoryFlow: 'useHistoryProgram',
  flowLogTimestamps: 'useFlowLogTimestamps',
  stationErrors: 'useStationErrors',
  areaZone: 'areasAndZones',
  hydraulic: 'useHydraulic',
  irrigation: 'irrigation',
  flowRule: 'flowRule',
  newRule: 'newRule',
  flowSensor: 'useFlowSensor',
  flowSensorDetail: 'flowSensorDetail',
  flowValveDetail: 'flowValveDetail',
  flowValve: 'useFlowValve',
  flowValveError: 'useFlowValve',
  ioOptions: 'ioOptions',
  ioValveOptions: 'ioValveOptions',
  sensorOptions: 'sensorOptions',
  pipe: 'usePipe',
  lineUnit: 'useLineUnits',
  sensorDetailCis: 'useSensorDetailCis',
  sensorDetail: 'useSensorDetail',
  soilMoisChart: 'useSoilMoisChart',
  soilLineUnit: 'useSoilLineUnit',
  soilIOReading: 'useSoilIOReadings',
  errorCode: 'ErrorCode',
  leafWetness: 'useLeafWetness',
  lineUnitDecoder: 'lineUnitDecoder',
  lineUnitControl: 'lineUnitControl',
  stationsProgram: 'useStationsProgram',
  reportFlowLog: 'reportFlowLog',
  projectWaterUsage: 'projectWaterUsage',
  stationRunTime: 'stationRunTime',
  programStart: 'programStart',
  programStartDays: 'programStartDays',
  programNextDays: 'programNextDays',
  stationStart: 'stationStart',
  stationStartDays: 'stationStartDays',
  MonthyRainFall: 'MonthyRainFall',
  monthlyETStart: 'monthlyETStart',
  avgTemp: 'avgTemp',
  avgTempStart: 'avgTempStart',
  actualTotalWaterUsage: 'actualTotalWaterUsage',
  actualTotalWaterUsageStart: 'actualTotalWaterUsageStart',
  globalExclusion: 'globalExclusion',
  zeus: 'zeus',
  comparisonData: 'comparisonData',
  comparisonSensor: 'comparisonSensor',
  comparisonWeatherData: 'comparisonWeatherData',
  fertigationGlobalDetail: 'fertigationGlobalDetail',
  manageUserList: 'manageUserList',
  globalConfiguration: 'globalConfiguration',
  mtdCostWater: 'mtdCostWater',
  estWaterUsage: 'estWaterUsage',
  financialWaterUsage: 'financialWaterUsage',
  financialCostWater: 'financialCostWater',
  avgDailyRainFall: 'avgDailyRainFall',
  avgTemperature: 'avgTemperature',
  avgDailyET: 'avgDailyET',
  chartTotalWaterUsage: 'chartTotalWaterUsage',
  chartMonthlyET: 'chartMonthlyET',
  chartWaterUsage: 'chartWaterUsage',
  chartWeatherInfo: 'chartWeatherInfo',
  diagnostics: 'diagnostics',
  waterTank: 'waterTank',
  waterTankSensor: 'waterTankSensor',
  waterTankTopupValve: 'waterTankTopupValve',
  waterTankLastUpdate: 'waterTankLastUpdate',
  userOrgExist: 'userOrgExist',
  waterSource: 'waterSource',
  useGetListWaterResourceReport: 'useGetListWaterResourceReport',
  waterTankLevelHistory: 'waterTankHistory',
  switchWireMode: 'switchWireMode',
  twowireTest: 'twowireTest',
  useGetListLeaksTable: 'useGetListLeaksTable',
  useGetListVoltagesTable: 'useGetListVoltagesTable',
  twowireById: 'twowireById',
  twowireByHub: 'twowireByHub',
  interfaceHeartbeatByHub: 'interfaceHeartbeatByHub',
  useGetFlowListDashboard: 'useGetFlowListDashboard',
  irrigationOverview: 'irrigationOverview',
  irrigationSimulation: 'irrigationSimulation',
  irrigationHistory: 'irrigationHistory',
  getFlowSensorsById: 'useGetFlowSensorsById',
  turfQuality: 'turfQuality',
  getWaterEngine: 'getWaterEngine',
  getListAsset: 'getListAsset',
  getOrganizationAsset: 'getOrganizationAsset',
  getMyOrganizationAsset: 'getMyOrganizationAsset',
  getListInterfaceAssetMapping: 'getListInterfaceAssetMapping',
}

export const mutationKey = {
  updateOrg: 'updateOrg',
  deleteOrg: 'deleteOrg',
  addOrg: 'addOrg',
  addInterfaceOrg: 'addInterfaceOrg',
  removeInterfaceOrg: 'removeInterfaceOrg',
  addUserOrg: 'addUserOrg',
  removeUserOrganizationExistingOrg: 'removeUserOrganizationExistingOrg',
  addInterfacePermissionsOrg: 'addInterfacePermissionsOrg',
  removeInterfacePermissionsOrg: 'removeInterfacePermissionsOrg',
  removeUserInterfaceAndOrg: 'removeUserInterfaceAndOrg',
  addAssetOrg: 'addAssetOrg',
  deleteAssetOrg: 'deleteAssetOrg',
  addInterfaceAssetMapping: 'addInterfaceAssetMapping',
  removeInterfaceAssetMapping: 'removeInterfaceAssetMapping',
  getListAsset: 'getListAsset',
}

export const XLSX_FORMAT = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]

export const XLSX_ACEPT = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
}

export const DATA_MODE = [
  {
    value: 1,
    label: 'Manual',
  },
  {
    value: 2,
    label: 'Auto',
  },
  {
    value: 3,
    label: 'Paused',
  },
]

export const DATA_DAYS_LIST = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },

  {
    value: 7,
    label: '7',
  },
  {
    value: 8,
    label: '8',
  },
  {
    value: 9,
    label: '9',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 11,
    label: '11',
  },
  {
    value: 12,
    label: '12',
  },
  {
    value: 13,
    label: '13',
  },
  {
    value: 14,
    label: '14',
  },
  {
    value: 15,
    label: '15',
  },
  {
    value: 16,
    label: '16',
  },
  {
    value: 17,
    label: '17',
  },
  {
    value: 18,
    label: '18',
  },
  {
    value: 19,
    label: '19',
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 21,
    label: '21',
  },
  {
    value: 22,
    label: '22',
  },
  {
    value: 23,
    label: '23',
  },
  {
    value: 24,
    label: '24',
  },
  {
    value: 25,
    label: '25',
  },
  {
    value: 26,
    label: '26',
  },
  {
    value: 27,
    label: '27',
  },
  {
    value: 28,
    label: '28',
  },
  {
    value: 29,
    label: '29',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 31,
    label: '31',
  },
]

export const DATA_DAYS_LIST_TWO = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },

  {
    value: 7,
    label: '7',
  },
  {
    value: 8,
    label: '8',
  },
  {
    value: 9,
    label: '9',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 11,
    label: '11',
  },
  {
    value: 12,
    label: '12',
  },
  {
    value: 13,
    label: '13',
  },
  {
    value: 14,
    label: '14',
  },
  {
    value: 15,
    label: '15',
  },
  {
    value: 16,
    label: '16',
  },
  {
    value: 17,
    label: '17',
  },
  {
    value: 18,
    label: '18',
  },
  {
    value: 19,
    label: '19',
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 21,
    label: '21',
  },
  {
    value: 22,
    label: '22',
  },
  {
    value: 23,
    label: '23',
  },
  {
    value: 24,
    label: '24',
  },
  {
    value: 25,
    label: '25',
  },
  {
    value: 26,
    label: '26',
  },
  {
    value: 27,
    label: '27',
  },
  {
    value: 28,
    label: '28',
  },
  {
    value: 29,
    label: '29',
  },
]
export const DATA_MINUTES_LIST = [
  {
    value: 1,
    label: 'Jan',
  },
  {
    value: 2,
    label: 'Feb',
  },
  {
    value: 3,
    label: 'Mar',
  },
  {
    value: 4,
    label: 'Apr',
  },
  {
    value: 5,
    label: 'May',
  },
  {
    value: 6,
    label: 'June',
  },
  {
    value: 7,
    label: 'July',
  },
  {
    value: 8,
    label: 'Aug',
  },
  {
    value: 9,
    label: 'Sep',
  },
  {
    value: 10,
    label: 'Oct',
  },
  {
    value: 11,
    label: 'Nov',
  },
  {
    value: 12,
    label: 'Dec',
  },
]

export const flyInVariants = {
  initial: {
    opacity: 0,
    x: '100vw',
    height: '100%',
  },
  initialSimulation: {
    opacity: 0,
    x: '-100vw',
    height: '100%',
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
      ease: 'easeOut',
    },
  },
  animate1: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
      ease: 'easeOut',
    },
  },
  animate2: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 2,
      ease: 'easeOut',
    },
  },
  animate3: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 2.5,
      ease: 'easeOut',
    },
  },
  animate4: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 3,
      ease: 'easeOut',
    },
  },
  animate5: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 3.5,
      ease: 'easeOut',
    },
  },
  animate6: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 4,
      ease: 'easeOut',
    },
  },
  animate7: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 4.5,
      ease: 'easeOut',
    },
  },
  animate8: {
    opacity: 1,
    x: '0', // di chuyển qua bên trái của màn hình
    transition: {
      duration: 12.5,
      ease: 'easeOut',
    },
  },
}

export const flyInVariantsDashboard = {
  initial: {
    opacity: 0,
    scale: 0.1,
    y: '100vh',
  },
  animateBoxDashboard: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: 'easeOut',
    },
  },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: 'easeOut',
    },
  },

  animateInitial: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 1.5,
      ease: 'easeOut',
    },
  },
  initialRight: {
    opacity: 0,
    x: '-100vw',
    height: '100%',
  },
  initialRight1: {
    opacity: 0,
    x: '-100vw',
  },
  initialLeft: {
    opacity: 0,
    x: '100vw',
    height: '100%',
  },
  initialController: {
    opacity: 0,
    x: '100vw',
    height: '100%',
  },

  animate2: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
      ease: 'easeOut',
    },
  },
  animate3: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1.5,
      ease: 'easeOut',
    },
  },
}

export enum SortBy {
  ID = 'id',
  WeatherLinkStationId = 'weatherLinkStationId',
  InterfaceName = 'interfaceName',
  Organization = 'organizationName',
  UpdateAt = 'updateAt',
  Country = 'country',
  CreateAt = 'createAt',
  Name = 'name',
  SiteName = 'name',
  NumberOfLocations = 'numberOfLocations',
  LocationName = 'locationame',
  NumberOfFloors = 'numberOfFloors',
  DescriptionOrg = 'description',
  AdminName = 'adminname',
  AdminEmail = 'adminemail',
  Role = 'role',
  UserName = 'username',
  Email = 'email',
  SourceName = 'sourceName',
  ProgramMode = 'programMode',
  State = 'state',
  Address = 'address',
  TWICustomName = 'twiCustomName',
  DecoderType = 'decoderType',
  Configuration = 'configuration',
  ConfigState = 'configState',
  Description = 'description',
  AllowableDepletion = 'allowableDepletion',
  RefillTo = 'refillTo',
  RootZone = 'rootZone',
  Factor = 'factor',
  WillingPoint = 'willingPoint',
  HoldingCapacity = 'holdingCapacity',
  IntakeRate = 'intakeRate',
  MaxSurfaceAccumulation = 'maxSurfaceAccumulation',
  Emitter = 'emitter',
  Efficiency = 'efficiency',
  Controller = 'controller',
  Plant = 'plant',
  ETRunTime = 'etRuntime',

  StationId = 'stationId', // Thêm cột StationId
  StationName = 'stationName', // Thêm cột Name
  Flow = 'flow', // Thêm cột Flow
}
